import ReactDOM from "react-dom";

import { banner, bannerMsg } from "./Banner.style";

/**
 * Display banner at the top of the application.
 */
const ExternalToolBanner = ({ children }) => {
  const root = document.getElementById("banner-root");

  const bannerEl = (
    <div css={banner}>
      <div css={bannerMsg}>{children}</div>
    </div>
  );

  return ReactDOM.createPortal(bannerEl, root);
};

export default ExternalToolBanner;
